import {signal} from "@preact/signals-react";

export const authorizedData = signal([])
export const isLoadingAuthorized = signal(false)